import type { IGetpaymentsRow, IPaymentsFetch, IStatuses, IStatusMap } from '../interfaces'
import type { AxiosResponse } from 'axios'

import $api, { payments, checkRegister } from '.'

export interface IGetPaymentsParams {
  countRows: number
  currentPage: number
  fromDate?: string
  toDate?: string
  groupName?: string
  statuses?: string
  locationId?: string
}

export interface IGetRow {
  groupNumber: string
  fileNames: string
  countRows: number
  currentPage: number
}
export interface IVoid {
  groupNumber: string
  fileNames: string
  entId: string
}
export interface IFilterPayments {
  filterLine?: string
  entIds?: string
}
export interface IFilterPaymentsResultObj {
  groupNumber: string
  groupName: string
}
export interface IFilterPaymentsResult {
  data: IFilterPaymentsResultObj[] | string[]
}
export interface IFetchVoid {
  newStatus: number
}
export interface IFetchStatuses {
  data: {
    statusMapping: IStatusMap
    statuses: IStatuses[]
    longTermStatuses: IStatuses[]
  }
}
export interface IFetchZelis {
  key: string
  EOBNumber: string
  fileName: string
  payMethod: string
  checkAmount: string
}
export interface IFetchZelisData {
  count: string
  data: IFetchZelis[]
}

export default class Payments {
  static async getPayments(params: IGetPaymentsParams): Promise<IPaymentsFetch> {
    return $api
      .get<IPaymentsFetch>(`${payments}/getData`, { params })
      .then((response: AxiosResponse) => {
        return { data: response.data, status: response.status }
      })
  }

  static async getPaymentsRow(params: IGetRow): Promise<IGetpaymentsRow> {
    return $api
      .get<IGetpaymentsRow>(`${payments}/getRowData`, { params })
      .then((response: AxiosResponse) => {
        return { data: response.data.data, count: response.data.count }
      })
  }

  static async void(param: IVoid): Promise<IFetchVoid> {
    return $api.post<IFetchVoid>(`${payments}/voidGroup`, param).then((response: AxiosResponse) => {
      return { newStatus: response.data.newStatus }
    })
  }

  static async rebuild(param: IVoid): Promise<IFetchVoid> {
    return $api
      .post<IFetchVoid>(`${checkRegister}/buildReport`, param)
      .then((response: AxiosResponse) => {
        return { newStatus: response.data.newStatus }
      })
  }

  static async getFilter(params: IFilterPayments): Promise<IFilterPaymentsResult> {
    return $api
      .get<IFilterPaymentsResult>(`${payments}/getGroups`, { params })
      .then((response: AxiosResponse) => {
        return { ...response.data }
      })
  }

  static async getStatuses(): Promise<IFetchStatuses> {
    return $api
      .get<IFetchStatuses>(`${payments}/getPaymentsFileStatuses`)
      .then((response: AxiosResponse) => {
        return { data: response.data }
      })
  }

  static async getZelis(params: IGetRow): Promise<IFetchZelisData> {
    return $api
      .get<IFetchZelisData>(`${payments}/getZelisPaymentsData`, { params })
      .then((response: AxiosResponse) => {
        return { data: response.data.data, count: response.data.count }
      })
  }
}
// http://localhost:3000/home/payment?fromDate=2022-06-27&toDate=2022-06-27&groupName=002360
